/* globals google */
import './search.scss';
import serializeForm from 'form-serialize';
import merge from 'lodash/merge';

/**
 * Legacy component
 */
function Search(element) {
	this.ui = {
		element: element
	};

	this.settings = merge(
		{
			apiKey: 'AIzaSyBj8Mq5YpRmCS0j2MuE1vMLjBUSUWhsQNY',
			stateClasses: {
				isVisible: 'is-visible',
				isLoading: 'is-loading'
			},
			i18n: {
				error: 'Leider wurden keine Resultate gefunden.'
			}
		},
		JSON.parse(this.ui.element.dataset.searchOptions || '{}')
	);

	this.init();
}

Search.prototype.init = function () {
	this.form = this.ui.element.querySelector('[data-search="form"]');
	this.results = this.ui.element.querySelector('[data-search="results"]');
	this.submit = this.ui.element.querySelector('[type="submit"]');
	this.isDbSearch = Boolean(this.form.dataset.source);
	this.isGoogleSearch = !this.isDbSearch;

	this.form.addEventListener('submit', event => {
		event.preventDefault();

		this._submit();
	});
};

Search.prototype._submit = function () {
	var formData = serializeForm(this.form, {
		hash: true
	});

	if (this.isDbSearch) {
		this.dbSearch(formData.query);
	} else {
		this.googleSearch(formData.query + ' ' + formData.type);
	}
};

Search.prototype.dbSearch = function (query) {
	var url = this.form.dataset.source + query;
	fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		}
	})
		.then(response => response.json())
		.then(data => {
			this.submit.removeAttribute('disabled');
			this.form.classList.remove(this.settings.stateClasses.isLoading);

			this.ui.element.classList.remove(this.settings.stateClasses.isLoading);
			this.results.classList.add(this.settings.stateClasses.isVisible);

			if (data.length > 0) {
				this._renderDbResults(data);
			} else {
				this._renderError();
			}
		})
		.catch(function () {
			this.submit.removeAttribute('disabled');
			this.form.classList.remove(this.settings.stateClasses.isLoading);

			// TODO dialog needed?
			this._renderError();
			return false;
		});

	return true;
};

Search.prototype.googleSearch = function (query) {
	window.open(`https://www.google.com/search?q=${query}`);
};

Search.prototype._renderDbResults = function (items) {
	var list = document.createElement('ul');

	this.results.innerHTML = '';
	this.results.appendChild(list);

	items.forEach(result => {
		var item = document.createElement('li'),
			searchValue = document.createElement('i'),
			name = document.createElement('div'),
			street = document.createElement('div'),
			address = document.createElement('div'),
			email = document.createElement('div'),
			phone = document.createElement('div');

		item.classList.add('search__results_item');

		if (items.length > 1) {
			searchValue.textContent = result.searchValue;
			item.appendChild(searchValue);
		}

		name.textContent = result.name;
		item.appendChild(name);

		street.textContent = result.street;
		item.appendChild(street);

		address.textContent = result.zip + ' ' + result.city;
		item.appendChild(address);

		if (result.phone) {
			this._appendLink(phone, 'tel:' + result.phone, result.phone);
			item.appendChild(phone);
		}

		if (result.email) {
			this._appendLink(email, 'mailto:' + result.email, result.email);
			item.appendChild(email);
		}

		list.appendChild(item);
	});
};

Search.prototype._renderGoogleResults = function (items) {
	var list = document.createElement('ul');

	this.results.innerHTML = '';
	this.results.appendChild(list);

	items.forEach(result => {
		var item = document.createElement('li'),
			address = document.createElement('div'),
			phone = document.createElement('div'),
			website = document.createElement('div');

		item.classList.add('search__results_item');
		item.textContent = result.name;

		address.textContent = result.formatted_address;

		item.appendChild(address);

		this.service.getDetails(
			{
				placeId: result.place_id
			},
			(result, status) => {
				if (status === google.maps.places.PlacesServiceStatus.OK && result) {
					if (result.formatted_phone_number) {
						this._appendLink(
							phone,
							'tel:' +
								(result.international_phone_number ||
									result.formatted_phone_number),
							result.formatted_phone_number
						);

						item.appendChild(phone);
					}

					if (result.website) {
						this._appendLink(website, result.website, result.website);

						item.appendChild(website);
					}
				}
			}
		);

		list.appendChild(item);
	});
};

Search.prototype._appendLink = function (item, url, text) {
	var link = document.createElement('a');

	link.setAttribute('href', url);
	link.setAttribute('target', '_blank');
	link.textContent = text;

	item.appendChild(link);
};

Search.prototype._renderError = function () {
	var error = document.createElement('div');

	error.classList.add('search__results_error');
	error.textContent = this.settings.i18n.error;

	this.results.innerHTML = '';
	this.results.appendChild(error);
};

function initSearch(element) {
	new Search(element);
}

document.querySelectorAll('[data-init~="search"]').forEach(element => {
	initSearch(element);
});

export { initSearch };
